import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Input } from 'components/fields'
import { CircleBadge, CenteredContent, Note, Title } from 'components/misc'
import { ElevatedButton } from 'components/layout'
import { form } from 'helpers/decorators'

@form({
  form: 'sendLeaderRequest',
  disableHook: true
})
class LeaderApproval extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    reset: PropTypes.func,
    colorClass: PropTypes.string
  }

  handleSubmit = fields =>
    this.props.onSubmit(fields, { resetForm: this.props.reset })

  render() {
    const { loading, colorClass, handleSubmit } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <CenteredContent marginAuto>
          <CircleBadge colorClass={colorClass} large medal>
            <i className="ico ico--icon-hand" />
          </CircleBadge>
        </CenteredContent>
        <Title
          colorClass={colorClass}
          h2
          style={{ textAlign: 'center', paddingTop: '10px' }}
        >
          <FormattedMessage
            id="moduleTitle.approved"
            defaultMessage="Approved!"
          />
        </Title>
        <Note margin="20px 0 30px">
          <FormattedMessage
            id="label.your_report_approve_now_send_to_leader"
            defaultMessage="Your Report has been approved. by Assessor. Now you can send to your Award Leader. If you want, you can add personal note also."
          />
        </Note>
        <Input
          name="note"
          intlKey="label.note_for_leader"
          label="Note for leader"
          optional
        />
        <ElevatedButton
          colorClass={colorClass}
          uppercase
          rounded
          submit
          padded
          fullWidth
          isLoading={loading}
          intlKey="button.send_for_approval"
        >
          Send for approval
        </ElevatedButton>
      </form>
    )
  }
}

export default LeaderApproval
